export default __webpack_public_path__ + "static/media/imagen__login.ff7421f2.jpeg";